// Bridge export to satisfy imports from '@lib/core/axios.client'
export { apiClient as default } from './axiosClient/client';
export * from './axiosClient/client';

